import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { Link } from 'react-router-dom';

const powwowIcon = L.divIcon({
  className: '',
  html: '<div class="powwow-pin"><span>P</span></div>',
  iconSize: [32, 42],
  iconAnchor: [16, 42],
  popupAnchor: [0, -38],
});

export default function MapView({ events = [], center = [39.5, -98.35], zoom = 4, height = '70vh' }) {
  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={{ height, width: '100%', borderRadius: '1rem' }}
      scrollWheelZoom
      data-testid="powwow-map"
    >
      <TileLayer
        attribution='&copy; OpenStreetMap &copy; CARTO'
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
      />
      {events.map((e) => (
        <Marker key={e.event_id} position={[e.lat, e.lng]} icon={powwowIcon}>
          <Popup>
            <div className="p-3 w-64" data-testid={`map-popup-${e.event_id}`}>
              {e.hero_image && (
                <img src={e.hero_image} alt={e.name} className="w-full h-28 object-cover rounded-lg mb-2" />
              )}
              <p className="text-[10px] uppercase tracking-widest text-turquoise font-semibold mb-1">{e.tribe}</p>
              <h4 className="font-display text-lg leading-tight mb-1 text-foreground">{e.name}</h4>
              <p className="text-xs text-muted-foreground mb-2">
                {e.city}, {e.state} · {e.start_date}
              </p>
              {e.total_prize_pool > 0 && (
                <p className="text-xs font-semibold text-gold mb-2">
                  Prize pool: ${e.total_prize_pool.toLocaleString()}
                </p>
              )}
              <Link
                to={`/events/${e.event_id}`}
                className="inline-block text-xs font-semibold text-turquoise hover:underline"
              >
                View details →
              </Link>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
